import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, FormControl, FormGroup, Glyphicon, HelpBlock, Panel, Table} from 'react-bootstrap';
import {withRouter} from 'react-router';
import {FaPencil, FaTrash} from 'react-icons/lib/fa/index';
import {removeQuestion, updateQuestion} from '../../utils/actions/createAssessment';
import {connect} from 'react-redux';

class EditAssessmentSubsection extends Component {

  onWeightChange = (qId, q, event) => {
    if(!isNaN(event.target.value) && +event.target.value >= 0) {
      q.weight = event.target.value;
      this.props.updateQuestion(this.props.id, qId, q);
    }
  };

  getSubsectionPoints = () => {
    let subsection = this.props.assessment.subsections[this.props.id];
    let val = 0;

    if (subsection.questions) {
      subsection.questions.forEach(q => {
        val += (+q.weight || 1) * Object.keys(q).filter(x => !isNaN(+x)).length;
      });
    }

    return val;
  };

  render() {
    return (
      <Panel className='m0 full-width'>
        <Panel.Heading>
          <Panel.Title>
            <div className='flex-row-spaced'>
              <FormGroup style={{ fontSize: 'initial', margin: '3px', width: '300px' }} validationState={this.props.error ? 'error' : null } controlId="formHorizontalSubsectionName">
                <FormControl value={this.props.name} onChange={this.props.onChange} placeholder='Enter Subsection Name'/>
                <FormControl.Feedback />
                { this.props.error ? <HelpBlock data-cy={`title-helpblock-${this.props.id}`} style={{ fontSize: '14px' }}>{this.props.error}</HelpBlock> : '' }
              </FormGroup>
              <div>
                <b>Points: </b>
                {
                  this.getSubsectionPoints()
                }
              </div>
            </div>
          </Panel.Title>
        </Panel.Heading>

        <Table>
          <thead>
            <tr>
              <th>#</th>
              <th>Question</th>
              <th>Weight</th>
              <th/>
            </tr>
          </thead>
          <tbody data-cy={`tbody-${this.props.id}`}>
          { this.props.questions &&
            this.props.questions.map((q,i) => {
              return (
                <tr key={i}>
                  <td style={{verticalAlign: 'middle'}}>{i+1}</td>
                  <td data-cy={`question-name-${this.props.id}-${i}`} style={{verticalAlign: 'middle'}}>{q.name}</td>
                  <td><FormControl type='text' value={q.weight} onChange={event => this.onWeightChange(i, q, event)} style={{width: '55px'}}/></td>
                  <td>
                    <div className="pull-right ml-auto">
                      <Button data-cy={`edit-button-${this.props.id}-${i}`} className='primary' onClick={() => this.props.history.push(`/assessments/create/edit-question/${this.props.id}/${i}`)}><FaPencil/></Button>
                      <Button data-cy={`delete-button-${this.props.id}-${i}`} className='primary' onClick={() => this.props.removeQuestion(this.props.id, i)}><FaTrash/></Button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        <Panel.Body>
          <div className='flex-row-spaced' style={{ marginTop: '4rem' }}>
            <Button data-cy={'add-question-button-' + this.props.id} style={{ marginRight: '10px', height: '40px' }} onClick={() => this.props.history.push(`/assessments/create/add-question/${this.props.id}`)}>
              <Glyphicon glyph={'plus-sign'}/>
            </Button>
            <Panel data-cy={'add-question-' + this.props.id} className='m0 full-width'>
              <Panel.Heading>
                <Panel.Title>Add Question</Panel.Title>
              </Panel.Heading>
            </Panel>
          </div>
        </Panel.Body>
      </Panel>
    );
  }
}

EditAssessmentSubsection.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
};

const mapStateToProps = state => {
  return ({
    ...state.createAssessment
  });
};

const mapDispatchToProps = dispatch => ({
  removeQuestion: (subId, qId) => dispatch(removeQuestion({subId, qId})),
  updateQuestion: (subId, qId, question) => dispatch(updateQuestion({ subId, qId, question }))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EditAssessmentSubsection));



// WEBPACK FOOTER //
// ./src/components/assessments/assessment-form/EditAssessmentSubsection.js